module.exports = __webpack_public_path__ + "img/list.ba2706dc.svg";